/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import {
  SectionRowElement,
  SectionRowElementBadge,
  SectionRowElementChart,
  SectionRowElementList,
  SectionRowElementTable,
  SectionRowElementText,
  SectionRowElementTypeEnum,
} from 'templates/pubSub/types/TemplateType';
import SectionElementContentText from './SectionElementContentText';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import SectionElementContentBadge from './SectionElementContentBadge';
import SectionElementContentChart from './SectionElementContentChart';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import SectionElementContentList from './SectionElementContentList';
import SectionElementContentTable from './SectionElementContentTable';

interface ISectionElementContentProps {
  templateContext: TemplateContext;
  element: SectionRowElement;
  cols: string;
  startingNodeId?: NodeIdentifier;
}

export default function SectionElementContent(props: ISectionElementContentProps): ReactElement {
  return (
    <>
      {props.element.type === SectionRowElementTypeEnum.TEXT && (
        <SectionElementContentText
          templateContext={props.templateContext}
          cols={props.cols}
          element={props.element as SectionRowElementText}
          startingNodeId={props.startingNodeId}
        />
      )}
      {props.element.type === SectionRowElementTypeEnum.CHART && (
        <SectionElementContentChart
          templateContext={props.templateContext}
          cols={props.cols}
          element={props.element as SectionRowElementChart}
          startingNodeId={props.startingNodeId}
        />
      )}
      {props.element.type === SectionRowElementTypeEnum.BADGE && (
        <SectionElementContentBadge
          templateContext={props.templateContext}
          cols={props.cols}
          element={props.element as SectionRowElementBadge}
          startingNodeId={props.startingNodeId}
        />
      )}
      {props.element.type === SectionRowElementTypeEnum.TABLE && (
        <SectionElementContentTable
          templateContext={props.templateContext}
          element={props.element as SectionRowElementTable}
          startingNodeId={props.startingNodeId}
        />
      )}
      {props.element.type === SectionRowElementTypeEnum.LIST && (
        <SectionElementContentList
          templateContext={props.templateContext}
          cols={props.cols}
          element={props.element as SectionRowElementList}
          startingNodeId={props.startingNodeId}
        />
      )}
    </>
  );
}
